import { render, staticRenderFns } from "./FunderMetaDataInput.vue?vue&type=template&id=7236267a&scoped=true&"
import script from "./FunderMetaDataInput.vue?vue&type=script&lang=ts&"
export * from "./FunderMetaDataInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236267a",
  null
  
)

export default component.exports